// src/pages/MypageInfo.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, TextField, Button, Typography, Container, Alert } from '@mui/material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from './components/Hamburger.jsx';

const MypageInfo = () => {
  const [formData, setFormData] = useState([]);
  const [editing, setEditing] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const [showFormMenu, setShowFormMenu] = useState(false);
  const [sendingReset, setSendingReset] = useState(false);
  const [mypageData, setMypageData] = useState(null);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res1 = await api.get(`/api/mypage/${user.mypage_id}`);
        setMypageData(res1.data);
        setFormData(res1.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const handleScrollTo = (id, targetUrl) => {
    if (targetUrl && window.location.pathname !== targetUrl) {
      // 別ページなら localStorage に保存して navigate
      localStorage.setItem('scrollToId', id);
      navigate(targetUrl);
    } else {
      // 同ページなら即スクロール
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };


  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    sessionStorage.clear(); // ← これ追加！
    navigate('/');
  };

  const handleSendResetLink = async () => {
    setSendingReset(true);
    try {
      const res = await api.post("/api/request-password-reset", {
        email: formData.email, // ←ここで現在表示中のユーザーのemailを使う
      });
      alert("パスワード再設定リンクをメールで送信しました");
    } catch (err) {
      console.error(err);
      alert("エラーが発生しました。");
    } finally {
      setSendingReset(false);
    }
  };

  const handleSubmit = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user);

    api.put(`/api/mypage/${user?.exhibitor_id}`, formData)
      .then(res => {
        alert("情報を更新しました");
        setEditing(false);
      })
      .catch(err => {
        console.error("更新失敗:", err);

        // ✅ バックエンドからのメッセージを優先して表示
        const message = err.response?.data?.detail || "更新に失敗しました";
        alert(message);
      });
  };

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
      <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
          <div className="submenu">
            {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
  );

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
      <Header
        title="SDGs 子ども・ユースフェア2026 出展者情報編集"
        companyName={mypageData?.company_name}
      />
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .sm-w-100 {width : 100%;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        .sm-w-100 {width: 80%;}
        }
        `}
      </style>
       <Container sx={{ display: 'flex' }}>
        <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
                className={`menu-item`}
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              {/* <Box 
                className="menu-item"
                onClick={() => {
                  if (canDownload) {
                    handlePdfDownload(mypageData.exhibitor_id, mypageData.company_name);
                  }
                }}
                style={{
                  cursor: canDownload ? "pointer" : "not-allowed",
                  opacity: canDownload ? 1 : 0.5,
                }}
              >
                見積書発行
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <Container className='sm-w-100'>
          <HamburgerMenu />
              <Box sx={{ margin: 'auto', mt: 4 }}>
                  <Typography variant="h6" gutterBottom>登録情報の編集</Typography>
                  <Typography variant="h5">小間番号：　{formData.booth_number}</Typography>

                  {['company_name', 'department', 'post', 'user_name', 'zip_code', 'address', 'phone_number', 'tel_number', 'email'].map(key => (
                      <TextField
                      key={key}
                      label={key === 'company_name' ? '会社名' :
                              key === 'department' ? '部署名' :
                              key === 'post' ? '役職名' :
                              key === 'user_name' ? '担当者名' :
                              key === 'zip_code' ? '郵便番号' :
                              key === 'address' ? '住所' :
                              key === 'phone_number' ? '電話番号' :
                              key === 'tel_number' ? '携帯電話番号' : 'メールアドレス'}
                      name={key}
                      value={formData[key] || ''}
                      onChange={handleChange}
                      fullWidth
                      margin="normal"
                      />
                  ))}

                  <Button variant="contained" color="primary" onClick={handleSubmit}>
                      保存
                  </Button>
              </Box>
              <Box sx={{ mt: 3 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleSendResetLink}
                  disabled={sendingReset}
                >
                  パスワードを変更する
                </Button>
              </Box>
        </Container>
       </Container>
       <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
    </div>
  );
};

export default MypageInfo;
